import { Component, OnInit } from '@angular/core';
import { FormControl,FormGroup} from '@angular/forms';
import { ElementCacheService} from '../../services/element-cache.service';
import { ElementCacheViewModalComponent} from '../../modals/element-cache-view-modal/element-cache-view-modal.component';
import { ModalService} from 'ngx-dynamic-modal';
import { AlertaService} from '../../../../../shared/services/alerta.service';
import {CacheDeleteFromFileModalComponent} from '../../modals/cache-delete-from-file-modal/cache-delete-from-file-modal.component';

@Component({
  selector: 'app-element-cache',
  templateUrl: './element-cache.component.html',
  styleUrls: ['./element-cache.component.scss']
})
export class ElementCacheComponent implements OnInit {

    formSearch: FormGroup;
    keys: Array<any>;
    isSubmitted: boolean;
    enabled: boolean;
    search = {
        cache_type: '',
        element:''
    };
    label: any;

  constructor(private elementCacheService: ElementCacheService,
              private modalService: ModalService ,
              private  alerta:AlertaService) {
      this.formSearch = new FormGroup(
          {
              'cache_type' : new FormControl(),
              'element': new FormControl()
          }
      );
      this.keys=[];
  }

  ngOnInit() {}

  searchKeys(form){
      this.isSubmitted=true;
      this.label=Object.assign({},this.search);
      if(form.valid){
            this.enabled=true;
            this.elementCacheService.getElementCacheEntries(this.search)
                .subscribe( result => {
                    this.keys=result;
                }, error => {
                    console.log(error);
                    }, () => {
                    this.enabled=false;
                })
        }

  }

  openModal(key){
      let entry={key:key.key,type:this.search.cache_type,element:this.search.element};
      this.modalService.addDynamicComponent(ElementCacheViewModalComponent, {entry}, (res) => {
          });
  }

  removeElement(key){
      this.alerta.addAlert('confirm','Do you want to Delete this key?')
              .then((result)=>{
                  if(result.value){
                      let entry={key:key.key,type:this.search.cache_type,element:this.search.element};
                      this.elementCacheService.removeElementCacheEntry(entry)
                          .subscribe( result => {
                          }, error => {
                              console.log(error);
                          }, () => {
                              this.alerta.addAlert('success','Key Deleted Succesfully!!')
                              let indx=this.keys.indexOf(key);
                              this.keys.splice(indx,1);
                          })}
              })
  }

  deleteFromFile(){
          this.modalService.addDynamicComponent(CacheDeleteFromFileModalComponent, {}, (res) => {
          });
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/components/element-cache/element-cache.component.ts